export const UsersTitle = ({ text }) => {
  return (
    <div className="text-[26px] font-bold web:mt-[65px] tablet:mt-[35px] mobile:mt-[35px] mb-[33px]">
      {text}
    </div>
  );
};
